__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "rescheduling-uimfe";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bsd/observability", "2.5.14", function() { return __webpack_require__.e(229).then(function() { return function() { return __webpack_require__(6229); }; }); });
			register("@bsd/ui-utils", "2.2.2", function() { return Promise.all([__webpack_require__.e(354), __webpack_require__.e(283), __webpack_require__.e(701)]).then(function() { return function() { return __webpack_require__(9354); }; }); });
			register("bxt-design-framework", "1.0.76", function() { return Promise.all([__webpack_require__.e(779), __webpack_require__.e(283), __webpack_require__.e(205), __webpack_require__.e(472), __webpack_require__.e(848)]).then(function() { return function() { return __webpack_require__(7779); }; }); });
			register("classnames", "2.2.6", function() { return __webpack_require__.e(485).then(function() { return function() { return __webpack_require__(32485); }; }); });
			register("moment", "2.29.4", function() { return Promise.all([__webpack_require__.e(595), __webpack_require__.e(358)]).then(function() { return function() { return __webpack_require__(95093); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(40961); }; }); });
			register("react-router-dom", "6.30.2", function() { return Promise.all([__webpack_require__.e(648), __webpack_require__.e(283), __webpack_require__.e(205)]).then(function() { return function() { return __webpack_require__(92648); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(540).then(function() { return function() { return __webpack_require__(96540); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};